export default [
  {
    path: '/PermissionDenied',
    name: 'PermissionDenied',
    meta: {
      keepAlive: false,
      pathName: '403',
    },
    component: resolve => require(['../view/error/403.vue'], resolve)
  },
  {
    path: '/ip_limit_error',
    name: 'ip_limit_error',
    meta: {
      keepAlive: false,
      pathName: 'ip_limit_error',
    },
    component: resolve => require(['../view/error/ip_limit_error.vue'], resolve)
  }, {
    path: '/token_error',
    name: 'token_error',
    meta: {
      keepAlive: false,
      pathName: 'token_error',
    },
    component: resolve => require(['../view/error/token_error.vue'], resolve)
  },
  {
    path: '*',
    name: '404',
    meta: {
      keepAlive: false,
      pathName: '404',
    },
    component: resolve => require(['../view/error/404.vue'], resolve)
  },
  {
    path: '*',
    name: '500',
    meta: {
      keepAlive: false,
      pathName: '500',
    },
    component: resolve => require(['../view/error/500.vue'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/router/errorPage.js